// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2rYeI","label":"Category_label__1FIcM","content":"Category_content__hyE9J","header":"Category_header__29wA5","location":"Category_location__3_cpQ"};